import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  showSubtext?: boolean;
}
export const Button = ({
  children,
  className = '',
  showSubtext = true,
  onClick,
  ...props
}: ButtonProps) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      onClick(e);
    } else {
      const target = document.getElementById('cta-final') || document.getElementById('offer');
      target?.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  return <div className={`flex flex-col items-center w-full ${className}`} data-id="element-172">
      <motion.button whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} onClick={handleClick} className="bg-terracotta hover:bg-[#B56A63] text-white font-semibold py-4 px-6 md:px-8 rounded-full shadow-lg transition-colors duration-300 w-full md:w-auto text-base md:text-lg lg:text-xl flex items-center justify-center text-center leading-tight" {...props} data-id="element-173">
        {children}
      </motion.button>
      {showSubtext && <div className="mt-3 flex flex-col items-center text-sm text-charcoal/70 space-y-1" data-id="element-174">
          <p data-id="element-175">Acceso inmediato tras la compra. Recíbelo directo en tu correo.</p>
          <div className="flex items-center gap-1 text-xs" data-id="element-176">
            <LockIcon size={12} data-id="element-177" />
            <span data-id="element-178">Pago 100% seguro y encriptado</span>
          </div>
        </div>}
    </div>;
};